import React from 'react';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../common/Forms/FormTextField';
import DropdownFormInput from '../../../../common/Forms/DropdownForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  setOrganizationName,
  setCity,
  setAlternateName,
  setAccountingContactId,
  setParentOrganizationId,
  setAdministrativeContactId,
  setFacilityCoordinatorContactId,
  setInvoiceVerificationContactId,
} from '../../../../../redux/organization/organizationForm/organizationFormSlice';
import { setOrgCity } from '../../../../../redux/organization/organizationTabs/addressAndContacts/addressAndContactsSlice';

const OrganizationField = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register, errors } = props;
  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { parentOrganizationList, accountingContactList, cityList } =
    organizationReferenceData;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        <FormInputText
          name='organizationName'
          type='text'
          control={control}
          errors={!!errors.organizationName}
          helperText={errors?.organizationName?.message}
          label='Organization Name'
          register={register('organizationName', {
            onChange: (e) => dispatch(setOrganizationName(e.target.value)),
          })}
        />
        <DropdownFormInput
          name='orgCity'
          control={control}
          options={cityList}
          defaultId={defaultValue?.orgCity}
          orgCity={true}
          label='City'
          register={register('orgCity', {
            onChange: (e) => {
              dispatch(setCity(e.target.value));
              dispatch(setOrgCity(e.target.value));
            },
          })}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormInputText
          name='alternateName'
          type='text'
          control={control}
          errors={!!errors.alternateName}
          helperText={errors?.alternateName?.message}
          label='Alternate Name (Short Name)'
          register={register('alternateName', {
            onChange: (e) => dispatch(setAlternateName(e.target.value)),
          })}
        />
        <DropdownFormInput
          name='accountingContactId'
          control={control}
          options={accountingContactList}
          defaultId={defaultValue?.accountingContactId}
          label='Accounting Contact'
          register={register('accountingContactId', {
            onChange: (e) => dispatch(setAccountingContactId(e.target.value)),
          })}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <DropdownFormInput
          name='parentOrganizationId'
          control={control}
          options={parentOrganizationList}
          defaultId={defaultValue?.parentOrganizationId}
          label='Parent Organization'
          register={register('parentOrganizationId', {
            onChange: (e) => dispatch(setParentOrganizationId(e.target.value)),
          })}
        />
        <DropdownFormInput
          name='administrativeContactId'
          control={control}
          options={accountingContactList}
          defaultId={defaultValue?.administrativeContactId}
          label='Administrative Contact'
          register={register('administrativeContactId', {
            onChange: (e) =>
              dispatch(setAdministrativeContactId(e.target.value)),
          })}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <DropdownFormInput
          name='facilityCoordinatorContactId'
          control={control}
          options={accountingContactList}
          defaultId={defaultValue?.facilityCoordinatorContactId}
          label='Facility Coordinator Contact'
          register={register('facilityCoordinatorContactId', {
            onChange: (e) =>
              dispatch(setFacilityCoordinatorContactId(e.target.value)),
          })}
        />
        <DropdownFormInput
          name='invoiceVerificationContactId'
          control={control}
          options={accountingContactList}
          defaultId={defaultValue?.invoiceVerificationContactId}
          label='Invoice Verification Contact'
          register={register('invoiceVerificationContactId', {
            onChange: (e) =>
              dispatch(setInvoiceVerificationContactId(e.target.value)),
          })}
        />
      </Grid>
    </Grid>
  );
};

export default OrganizationField;
